import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ChevronDown, Plus } from 'lucide-react';
import { ResourceList } from '../resourceList';
import { ResourcePickerProps } from './types';

export const ResourcePicker = ({
  open,
  onOpenChange,
  options,
  selected,
  onToggle,
  addLabel,
  searchPlaceholder,
  hint,
  conflictTitle,
  disabled,
}: ResourcePickerProps) => {
  const { t } = useTranslation('app');
  const [pinned, setPinned] = useState<string[]>([]);

  const toggleOpen = (next: boolean) => {
    if (next) setPinned(selected);
    onOpenChange(next);
  };

  if (!open)
    return (
      <button
        type="button"
        disabled={disabled}
        onClick={() => toggleOpen(true)}
        className="flex h-10 items-center gap-1.5 rounded-md border-[1.5px] border-neutral-300 bg-white px-2.5 text-[15px] text-neutral-400 disabled:bg-neutral-50">
        <Plus className="h-4 w-4" />
        <span className="flex-1 text-left">{addLabel}</span>
        <ChevronDown className="h-4 w-4" />
      </button>
    );

  return (
    <div className="flex flex-col gap-1.5">
      <ResourceList
        autoFocus
        options={options}
        checked={selected}
        pinned={pinned}
        onPick={onToggle}
        searchPlaceholder={searchPlaceholder}
        conflictTitle={conflictTitle}
        boxClassName="overflow-hidden rounded-md border border-neutral-200 bg-white shadow-[0_8px_19px_rgba(20,30,45,.12)]"
        listClassName="max-h-60 overflow-y-auto overscroll-contain"
        footer={
          <div className="flex items-center justify-between border-t border-neutral-100 py-0.5 pl-3 pr-1.5">
            <span className="text-[11px] text-neutral-400">{hint}</span>
            <button
              type="button"
              onClick={() => toggleOpen(false)}
              className="h-9 px-2 text-[13px] font-bold tracking-wide text-primary-600">
              {t('actions.close').toLocaleUpperCase()}
            </button>
          </div>
        }
      />
    </div>
  );
};
